import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { ChecklistIcon } from '../widgets/ChecklistIcon'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { Box, Grid, Paper, Tab, Tabs, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { useThemeMode } from '../../../theme'

const makeStyles = (palette) => ({
  header: {
    grid: { px: 2, pt: 1, pb: 1, alignItems: 'center', maxWidth: '700px', margin: '0 auto' },
    iconCol: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
    contentCol: { display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'center' },
    title: { color: palette.headerColor, lineHeight: 1.2 }
  },
  tabs: {
    background: palette.headerTransparentColor,
    height: '50px',
    '& .Mui-selected': {
      color: `${palette.paperColor} !important`
    },
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    }
  },
  stickyTabs: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    height: '50px'
  }
})

const paths = ['/achievements', '/achievements/user']

export const Menu = () => {
  const { t } = useTranslation()
  const { palette } = useThemeMode()
  const { pathname } = useLocation()
  const loggedIn = useSelector((state) => state?.auth?.profile ?? false)
  const styles = makeStyles(palette)
  const selected = paths.indexOf(pathname) >= 0 ? paths.indexOf(pathname) : 0

  const userTab = loggedIn
    ? (<Tab component={Link} to="/achievements/user" icon={<CheckBoxIcon />} aria-label={t('user-achievements')} />)
    : undefined

  return (
    <>
      <Box sx={styles.stickyTabs}>
        <Tabs aria-label="achievements menu tabs" value={selected} sx={styles.tabs}
          TabIndicatorProps={{ style: { backgroundColor: palette.headerColor } }}
        >
          <Tab component={Link} to="/achievements" icon={<ListAltIcon />} aria-label={t('all-achievements')} />
          {userTab}
        </Tabs>
      </Box>
      <Paper elevation={2} square>
        <Grid container sx={styles.header.grid}>
          <Grid item xs={3} sx={styles.header.iconCol}>
            <ChecklistIcon sx={{ fontSize: 48, fill: palette.headerColor }} />
          </Grid>
          <Grid item xs={9} sx={styles.header.contentCol}>
            <Typography variant="subtitle1" fontWeight={700} sx={styles.header.title}>
              {t(pathname === '/achievements/user' ? 'user-achievements' : 'all-achievements')}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}
